import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/Security.css';

const Security = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="security" className="security-section">
      <div className="section-container">
        <h2>{t.securityTitle}</h2>
        <p className="section-subtitle">{t.securitySubtitle}</p>
        
        <div className="security-grid">
          <div className="security-card">
            <div className="security-icon">
              <svg viewBox="0 0 24 24" width="56" height="56" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
              </svg>
            </div>
            <div className="security-content">
              <h3>{t.security1Title}</h3>
              <p>{t.security1Desc}</p>
              <ul>
                <li>Regulated onboarding flow</li>
                <li>Wallet ↔ legal entity binding</li>
                <li>Jurisdictional access controls</li>
                <li>Real-time sanctions screening</li>
              </ul>
            </div>
          </div>
          
          <div className="security-card">
            <div className="security-icon">
              <svg viewBox="0 0 24 24" width="56" height="56" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
            <div className="security-content">
              <h3>{t.security2Title}</h3>
              <p>{t.security2Desc}</p>
              <ul>
                <li>Native account model extension</li>
                <li>Protocol-level identity & role registry</li>
                <li>Built-in vault policy engine</li>
                <li>Runtime enforcement for all account types</li>
              </ul>
            </div>
          </div>
          
          <div className="security-card">
            <div className="security-icon">
              <svg viewBox="0 0 24 24" width="56" height="56" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <div className="security-content">
              <h3>{t.security3Title}</h3>
              <p>{t.security3Desc}</p>
              <ul>
                <li>Behavioral forensics</li>
                <li>Flow-of-funds tracking</li>
                <li>Smart contract counterparty scoring</li>
                <li>Peg risk analytics</li>
              </ul>
            </div>
          </div>
          
          <div className="security-card">
            <div className="security-icon">
              <svg viewBox="0 0 24 24" width="56" height="56" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"></path>
              </svg>
            </div>
            <div className="security-content">
              <h3>{t.security4Title}</h3>
              <p>{t.security4Desc}</p>
              <ul>
                <li>Chain-wide compliance hooks</li>
                <li>Native message mapping for off-chain custody</li>
                <li>Exposed handlers for off-chain triggers</li>
                <li>Immutable, upgradable system contracts</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security;